export const Baron = (color) => {
  return `
        <svg xmlns="http://www.w3.org/2000/svg" width="400" height="180" viewBox="0 0 400 180" fill="none">
          <g filter="url(#filter0_i_71_129)">
          <path d="M0 0H201.005V46.5517H0V0Z" fill="${color}"/>
          </g>
          <g filter="url(#filter1_i_71_129)">
          <path d="M198.995 0H400V46.5517H198.995V0Z" fill="${color}"/>
          </g>
          <g filter="url(#filter2_i_71_129)">
          <path d="M0 44.4828H201.005V91.0345H0V44.4828Z" fill="${color}"/>
          </g>
          <g filter="url(#filter3_i_71_129)">
          <path d="M198.995 44.4828H400V91.0345H198.995V44.4828Z" fill="${color}"/>
          </g>
          <g filter="url(#filter4_i_71_129)">
          <path d="M0 88.9656H201.005V135.517H0V88.9656Z" fill="${color}"/>
          </g>
          <g filter="url(#filter5_i_71_129)">
          <path d="M198.995 88.9656H400V135.517H198.995V88.9656Z" fill="${color}"/>
          </g>
          <g filter="url(#filter6_i_71_129)">
          <path d="M0 133.448H201.005V180H0V133.448Z" fill="${color}"/>
          </g>
          <g filter="url(#filter7_i_71_129)">
          <path d="M198.995 133.448H400V180H198.995V133.448Z" fill="${color}"/>
          </g>
          <defs>
          <filter id="filter0_i_71_129" x="-2" y="-2" width="203.005" height="48.5518" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
          <feFlood flood-opacity="0" result="BackgroundImageFix"/>
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
          <feMorphology radius="2" operator="dilate" in="SourceAlpha" result="effect1_innerShadow_71_129"/>
          <feOffset dx="-4" dy="-4"/>
          <feGaussianBlur stdDeviation="2"/>
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
          <feBlend mode="normal" in2="shape" result="effect1_innerShadow_71_129"/>
          </filter>
          <filter id="filter1_i_71_129" x="196.995" y="-2" width="203.005" height="48.5518" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
          <feFlood flood-opacity="0" result="BackgroundImageFix"/>
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
          <feMorphology radius="2" operator="dilate" in="SourceAlpha" result="effect1_innerShadow_71_129"/>
          <feOffset dx="-4" dy="-4"/>
          <feGaussianBlur stdDeviation="2"/>
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
          <feBlend mode="normal" in2="shape" result="effect1_innerShadow_71_129"/>
          </filter>
          <filter id="filter2_i_71_129" x="-2" y="42.4828" width="203.005" height="48.5518" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
          <feFlood flood-opacity="0" result="BackgroundImageFix"/>
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
          <feMorphology radius="2" operator="dilate" in="SourceAlpha" result="effect1_innerShadow_71_129"/>
          <feOffset dx="-4" dy="-4"/>
          <feGaussianBlur stdDeviation="2"/>
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
          <feBlend mode="normal" in2="shape" result="effect1_innerShadow_71_129"/>
          </filter>
          <filter id="filter3_i_71_129" x="196.995" y="42.4828" width="203.005" height="48.5518" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
          <feFlood flood-opacity="0" result="BackgroundImageFix"/>
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
          <feMorphology radius="2" operator="dilate" in="SourceAlpha" result="effect1_innerShadow_71_129"/>
          <feOffset dx="-4" dy="-4"/>
          <feGaussianBlur stdDeviation="2"/>
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
          <feBlend mode="normal" in2="shape" result="effect1_innerShadow_71_129"/>
          </filter>
          <filter id="filter4_i_71_129" x="-2" y="86.9656" width="203.005" height="48.5518" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
          <feFlood flood-opacity="0" result="BackgroundImageFix"/>
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
          <feMorphology radius="2" operator="dilate" in="SourceAlpha" result="effect1_innerShadow_71_129"/>
          <feOffset dx="-4" dy="-4"/>
          <feGaussianBlur stdDeviation="2"/>
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
          <feBlend mode="normal" in2="shape" result="effect1_innerShadow_71_129"/>
          </filter>
          <filter id="filter5_i_71_129" x="196.995" y="86.9656" width="203.005" height="48.5518" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
          <feFlood flood-opacity="0" result="BackgroundImageFix"/>
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
          <feMorphology radius="2" operator="dilate" in="SourceAlpha" result="effect1_innerShadow_71_129"/>
          <feOffset dx="-4" dy="-4"/>
          <feGaussianBlur stdDeviation="2"/>
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
          <feBlend mode="normal" in2="shape" result="effect1_innerShadow_71_129"/>
          </filter>
          <filter id="filter6_i_71_129" x="-2" y="131.448" width="203.005" height="48.5517" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
          <feFlood flood-opacity="0" result="BackgroundImageFix"/>
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
          <feMorphology radius="2" operator="dilate" in="SourceAlpha" result="effect1_innerShadow_71_129"/>
          <feOffset dx="-4" dy="-4"/>
          <feGaussianBlur stdDeviation="2"/>
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
          <feBlend mode="normal" in2="shape" result="effect1_innerShadow_71_129"/>
          </filter>
          <filter id="filter7_i_71_129" x="196.995" y="131.448" width="203.005" height="48.5517" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
          <feFlood flood-opacity="0" result="BackgroundImageFix"/>
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
          <feMorphology radius="2" operator="dilate" in="SourceAlpha" result="effect1_innerShadow_71_129"/>
          <feOffset dx="-4" dy="-4"/>
          <feGaussianBlur stdDeviation="2"/>
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
          <feBlend mode="normal" in2="shape" result="effect1_innerShadow_71_129"/>
          </filter>
          </defs>
          </svg>
        `;
};
